module.exports = __webpack_public_path__ + "img/bnr_app-s.25f89163.png";